import React, { useState, useEffect, useCallback, Fragment, useMemo } from "react";
import classNames from "classnames/bind";
import { PlayBackContext } from "../../contexts";
import SideBarPlayBack from "./Sidebar/SideBarPlayBack";
import Filter from "./Filter/Filter";
import axiosClient from "../../services/axiosClient";
import { formatDateYesterday, formatDB } from "../../utils";
import styles from "./PlayBack.module.css";
import VideoPlayBack from "./VideoPlayBack";
import { Alert, TimeLine, Toast } from "../../components";
import { useStoreContext } from "../../hooks/useStoreContext";
import Header from "./VideoPlayBack/Header";
import { useTranslation } from "react-i18next";
import { Col, Row, Space, Tag } from "antd";
import { useSearchParams } from "react-router-dom";
import { actions } from "../../store";
import AlertInstallPlugin from "../../components/AlertInstallPlugin/AlertInstallPlugin";
import { DownIcon, SettingIcon } from "../../components/Icons/Icons";
import plugin from "../../assets/plugin/CameraPluginSetup.exe";
import { useRtspToHls } from "../../hooks/useRtspToHls";
const cx = classNames.bind(styles);
const PlayBack = ({ onlyVideo = false }) => {
  const [searchParams] = useSearchParams();
  const [cameraCode, setCameraCode] = useState("");
  const [isShow, setIsShow] = useState(false);
  const [url, setUrl] = useState();
  const [timeH, setTimeH] = useState("00:00:00")
  const [name, setName] = useState();
  const [data, setData] = useState([]);
  const [timeStart, setTimeStart] = useState();
  const [hourStart, setHourStart] = useState();
  const [hourEnd, setHourEnd] = useState();
  const [isFilterHour, setIsFilterHour] = useState(true);
  const [screen, setScreen] = useState(1);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [hour, setHour] = useState("00:00:00");
  const [type, setType] = useState(24);
  const [count, setCount] = useState(0);
  const [dayPlayBack, seDayPlayBack] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModalDl, setShowModalDl] = useState(false);
  const [locate, setLocate] = useState(0);
  const [speedPB, setSpeedPB] = useState({ name: "x1", value: 1 });
  const [totalPage, setTotalPage] = useState(1);
  const { t } = useTranslation()
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  // eslint-disable-next-line
  const [isApply, setIsApply] = useState();
  const [isNotPlugin, setIsNotPlugin] = useState(false);

  const pluginPlayback = useMemo(() => {
    return localStorage.getItem("isPluginPlayback");
  }, [])

  const checkApiPlugin = async () => {
    try {
      // local api plugin
      await fetch("http://localhost:25699/api/hello");
      localStorage.setItem("isPluginPlayback", 'installed');
      return true;
    } catch (error) {
      return false;
    }
  }

  const onChangeTimeStart = (data) => {
    setTimeStart(data);
    // setCurrentPage(1);
  };
  const handleOke = (start, end) => {
    setIsFilterHour(true);
    setHourStart(start);
    setHourEnd(end);
  };
  const changeScreen = useCallback((data) => {
    setScreen(data);
  }, []);
  const changeFullScreen = useCallback((data) => {
    setIsFullScreen(data);
  }, []);

  const handleCheckResourcePlayback = async (listCameraSource) => {
    if (!listCameraSource || pluginPlayback === "installed") return;
    // check api - case clear cache
    const checkApi = await checkApiPlugin();
    if (checkApi) return;
    const resource = listCameraSource?.find(item => item?.recorder_code !== 'OTHER');
    setIsNotPlugin(!!resource);
  }

  useState(() => {
    const dateNow = new Date();
    const time = formatDateYesterday(dateNow);
    setTimeStart(time);
  }, [cameraCode]);
  const getFormatListCode = () => {
    let listCameraChoose = [];
    dataStore.listCodeCamera.forEach((element) => {
      listCameraChoose = [...listCameraChoose, ...element.data];
    });
    const index = listCameraChoose?.findIndex((item) => item.code === "");
    if (index >= 0) {
      listCameraChoose?.splice(index, 1);
    }
    setTotalPage(listCameraChoose?.length);
    const listCode = []; //listCameraChoose.map((camera) => camera)
    listCameraChoose.forEach((element, index) => {
      // Nếu màn hình đang xem là 1 thì chỉ lấy path của video đang xem
      if (screen === 1) {
        if (index === currentPage - 1) {
          listCode?.push(element);
        }
      } else {
        listCode.push(element);
      }
    });
    const newData = listCode.map((item) => {
      return {
        camera_code: item.code,
      };
    });
    const dataJSON = {
      data: newData,
    };
    return { listCamera: listCode, data: dataJSON };
  };

  useEffect(() => {
    const listCodeCamera = getFormatListCode();
    async function getListPlayBack() {
      try {
        const dataCode = JSON.stringify(listCodeCamera.data);
        const res = await axiosClient.get(
          `/camPlayback/get-list-path-timeline/`,
          {
            params: {
              list_camera_code: dataCode,
              day: formatDB(timeStart),
              time_line: hour,
            },
          }
        );
        handleCheckResourcePlayback(res?.time_line);
        seDayPlayBack(...res.day_playback);
        const listVideoPlay = getListPathVideo(
          res.time_line,
          listCodeCamera.listCamera
        );

        setCount(listVideoPlay.length);
        setData(listVideoPlay);
      } catch (e) { }
    }
    if (listCodeCamera.data.data.length > 0) {
      getListPlayBack();
    } else {
      setData([]);
      setCount(0);
    }
  }, [
    cameraCode,
    timeStart,
    hourStart,
    // hourEnd,
    dataStore.listCodeCamera,
    isFilterHour,
    hour,
    currentPage,
    screen,
  ]);
  useEffect(() => {
    const cameraCode = searchParams.get('camera_code');
    const warehouse = searchParams.get('warehouse');
    const nameCam = searchParams.get('name_cam');
    let dataAdd = {
      type: 'cam',
      add: true,
      data: [{ name: nameCam, code: cameraCode, status: true }],
      warehouseCode: warehouse,
    }
    if (warehouse && nameCam && cameraCode) {
      dispatch(actions.getListCodeCamera(dataAdd))
    }
  }, [])
  const getListPathVideo = (apiData, cameraChoose) => {
    const listCameraView = cameraChoose.map((camera) => {
      const indexOfElement = apiData.findIndex(
        (item) => item.camera_code === camera.code
      );
      if (indexOfElement >= 0) {
        return apiData.find((item) => item.camera_code === camera.code);
      } else {
        return {
          camera_code: camera.code,
          name_cam: camera.name,
          path: null,
          status: "no-video",
        };
      }
    });
    return listCameraView;
  };

  const onCancelAlertDownloadPlugin = async () => {
    const checkApi = await checkApiPlugin();
    if (checkApi) {
      setIsNotPlugin(!checkApi);
    } else {
      Toast.open("Bạn chưa thực hiện cài đặt plugin", "danger");
    }
  }

  const renderPluginInstall = () => {
    return (
      <Space size={'small'} direction="vertical">
        Để xem lại video từ đầu ghi cần cài plugin hỗ trợ này.
        <a href={plugin} download={true} >
          <Tag>
            <Space>
              <div style={{ marginTop: 4 }}>
                <SettingIcon />
              </div>
              VNS Plugin PlayBack
            </Space>
          </Tag>
        </a>
      </Space>
    )
  }

  return (
    <PlayBackContext.Provider
      value={{
        cameraCode,
        setCameraCode,
        isShow,
        setIsShow,
        url,
        setUrl,
        name,
        setName,
        setTimeStart,
        hour,
        timeStart,
        count,
        setIsApply,
        dayPlayBack,
        seDayPlayBack,
        currentPage,
        setCurrentPage,
        showModalDl,
        setShowModalDl,
        speedPB, setSpeedPB
      }}
    >
      {isNotPlugin && <AlertInstallPlugin content={renderPluginInstall()} onClose={onCancelAlertDownloadPlugin} />}
      <Row wrap={false} className={cx("container")}>
        <Col lg={5} sm={0.1} xs={0.1}>
          {
            !onlyVideo && (
              <SideBarPlayBack isRecord />
            )
          }
        </Col>
        <Col lg={19} sm={23} xs={23}>
          <div className={cx("content")}>
            <div className={cx("header")}>
              <h1 className={cx("title")}>{t("playback.playback")}</h1>
              {!isFullScreen && (
                <Header
                  screen={screen}
                  setScreen={changeScreen}
                  isFullScreen={isFullScreen}
                  setIsFullScreen={changeFullScreen}
                  onlyVideo={onlyVideo}
                />
              )}
            </div>
            <div className={cx("data")}>
              <Row wrap className={cx('row_wrapper')}>
                <Col xs={24} sm={24} lg={16}>
                  <div className={cx("content-video")}>
                    <VideoPlayBack
                      cameraSelect={data}
                      screen={screen}
                      changeScreen={changeScreen}
                      isFullScreen={isFullScreen}
                      changeFullScreen={changeFullScreen}
                      showModalDl={showModalDl}
                      setShowModalDl={setShowModalDl}
                      totalPages={totalPage}
                    />
                    {data.length > 0 &&
                      data.map((item, index) => {
                        if (screen === 1) {
                          return (
                            <TimeLine
                              camera={item}
                              timeStart={timeStart}
                              list={getFormatListCode}
                              type={type}
                              setHour={setHour}
                              hour={hour}
                              currentPage={currentPage}
                              screen={screen}
                              index={index}
                              length={data.length}
                              timeH={timeH}
                              setTimeH={setTimeH}
                              locate={locate}
                              setLocate={setLocate}
                            />
                          );
                        } else {
                          if (index >= screen * (currentPage - 1) && index < screen * (currentPage)) {
                            return (
                              <TimeLine
                                camera={item}
                                timeStart={timeStart}
                                list={getFormatListCode}
                                type={type}
                                setHour={setHour}
                                hour={hour}
                                currentPage={currentPage}
                                screen={screen}
                                index={index}
                                length={data.length}
                                timeH={timeH}
                                setTimeH={setTimeH}
                                locate={locate}
                                setLocate={setLocate}
                              />
                            );
                          }
                          else {
                            return <Fragment />
                          }
                        }
                      })}
                  </div>
                </Col>
                <Col xs={24} sm={24} lg={8}>
                  <div className={cx("filter")}>
                    <Filter
                      setType={setType}
                      onChangeDayStart={onChangeTimeStart}
                      timeStart={timeStart}
                      isFilter={isFilterHour}
                      onOk={handleOke}
                      setShowModalDl={setShowModalDl}
                      showModalDl={showModalDl}
                      day={dayPlayBack}
                      setSpeedPB={setSpeedPB}
                      speedPB={speedPB}
                    />
                  </div></Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </PlayBackContext.Provider>
  );
};
export default PlayBack;
